module.exports = __webpack_public_path__ + "img/range.1311b197.svg";